import axios from 'axios';
import store from '../store';
import router from '../routes/router';
import { isNullOrEmpty } from './utils';

export const putSectionResponses = async (categoryQuestionIds, config) => {
  // Prevent unnecessary calls to the server.
  if (isNullOrEmpty(categoryQuestionIds)) {
    return 'Empty data parameter';
  }

  let url = `${process.env.VUE_APP_API_URL}surveys/${store.state.activeSurvey.surveyUrlId}/users/${store.state.surveyUser.orgSurveyUserId}/responses`;
  let userResponses = [];
  let cfg = config ? config : {};

  categoryQuestionIds.forEach(id => {
    let stateResponsesById = store.getters.getQuestionResponses(id);
    userResponses = [...userResponses, ...stateResponsesById];
  });

  // Prevent unnecessary calls to the server.
  if (isNullOrEmpty(userResponses)) {
    return 'No responses found';
  }

  if(cfg.hasOwnProperty('headers')) {
    // assume only passed in header is an Authorization Bearer token.
    url += '/auth';
  }

  return await axios.put(url, userResponses, cfg);
}

export const getNavigationSectionId = (routeSectionId, isReview) => {
  let sectionId = store.getters.activeSurveyNavSections[0].id;

  if(store.state.surveyUser.lastSectionId !== null) {
    sectionId = store.state.surveyUser.lastSectionId;
  }
  else if(routeSectionId) {
    let section = store.getters.getNavSectionById(+routeSectionId);

    if(section && (section.viewed === true || isReview === true)) {
      sectionId = routeSectionId;
    }
  }

  return sectionId;
}

export const logSectionAccess = () => {
  let url = `${process.env.VUE_APP_API_URL}surveys/${store.state.activeSurvey.surveyUrlId}/users/${store.state.surveyUser.orgSurveyUserId}/sectionLog`;
  let sectionLog = {
    activeSectionId: store.state.activeSectionId,
    previousSectionId: store.state.previousSectionId
  }

  return axios.post(url, sectionLog);
}

export const handleUnauthorizedError = (error) => {
  let rerouted = false;
  let surveyId = router.currentRoute.params.surveyId;

  if(error.response && error.response.status === 401) {
    if(error.response.data === 'NOT_STARTED') {
      router.replace({ name: 'Info', params: {
        type: 'not started',
        surveyId: surveyId
      }});
      rerouted = true;
    }
    else if(error.response.data === 'ENDED') {
      router.replace({ name: 'Info', params: {
        type: 'ended',
        surveyId: surveyId
      }});
      rerouted = true;
    }
    else {
      router.replace({ path: `/surveys/${surveyId}/login` });
      rerouted = true;
      if (process.env.NODE_ENV === 'development') {
        throw new Error('UNAUTHORIZED');
      }
    }
  }
  else if(error === 'completed') {
    router.replace({ name: 'Info', params: {
      type: 'completed',
      surveyId: surveyId
    }});
    rerouted = true;
  }

  if(!rerouted) {
    router.replace({ name: 'Welcome'});
  }
}
